import { For, Show, createSignal } from "solid-js";
import * as api from "../api";
import type { Proposal } from "../api";
import type { Rematches } from "../game/rematches";
import { t } from "../strings";

/** How a proposal ended, in words. */
export function rematchEndText(p: Proposal): string {
  return t.rematchEnds[p.ended ?? ""]?.(p.ended_by ?? "") ?? t.rematchClosed;
}

// The bubble (design 14 §8.2): each open proposal in a corner of every page, with its answer; a click anywhere else on
// it goes back to the table's end screen, where it does not show: that screen says the same and more.
export function RematchBubbles(props: { rematches: Rematches; path: string; go: (p: string) => void }) {
  const here = (p: Proposal) => props.path === `/t/${p.token}`;
  const [error, setError] = createSignal("");
  const accept = (p: Proposal) => {
    setError("");
    props.rematches.accept(p.token).catch((err: unknown) => {
      if (err instanceof api.ApiError && err.status !== 409) setError(err.message);
    });
  };
  return (
    <div class={`rematch-bubbles${props.path.startsWith("/t/") ? " at-table" : ""}`}>
      <For each={props.rematches.bubbles().filter((p) => !here(p))}>
        {(p) => (
          <div class="rematch-bubble" role="status" onClick={() => props.go(`/t/${p.token}`)}>
            <Show when={!p.ended} fallback={<span>{rematchEndText(p)}</span>}>
              <Show
                when={p.accepted}
                fallback={
                  <>
                    <span>{t.rematchAsked(p.proposer_name, p.ready)}</span>
                    <span class="row">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          accept(p);
                        }}
                      >
                        {t.accept}
                      </button>
                      <button
                        type="button"
                        class="secondary"
                        onClick={(e) => {
                          e.stopPropagation();
                          props.rematches.decline(p.token);
                        }}
                      >
                        {t.decline}
                      </button>
                    </span>
                  </>
                }
              >
                <span>{t.rematchWaiting(p.ready)}</span>
                <button
                  type="button"
                  class="secondary"
                  onClick={(e) => {
                    e.stopPropagation();
                    props.rematches.decline(p.token);
                  }}
                >
                  {t.cancel}
                </button>
              </Show>
            </Show>
            <Show when={error()}>
              <span class="small">{error()}</span>
            </Show>
          </div>
        )}
      </For>
    </div>
  );
}
